module.exports = __webpack_public_path__ + "static/media/bell (1).5205325a.svg";